import baseClient from './apiClient';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import tokenService from '@/services/token.service';
import { handleErrorResponse } from './helper';
import router from '@/router';
import { useSessionStore } from '@/stores/session.store';

const interceptorConfig = baseClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const sessionStore = useSessionStore();
    config.headers = {
      Authorization: `Bearer ${tokenService.getToken()}`,
      ...(!router.currentRoute.value.meta?.isAdmin && sessionStore.currentOrganisationId
        ? { 'Current-Organisation': sessionStore.currentOrganisationId }
        : {}),
      ...config.headers
    };
    return config;
  },
  (error: any) => Promise.reject(error)
);

const interceptorErrors = baseClient.interceptors.response.use(
  (response: AxiosResponse) => response.data,
  (error: any) => {
    handleErrorResponse(error);
    return Promise.reject(error);
  }
);

export default { interceptorConfig, interceptorErrors };
